<section class="ndf-calculator-list" *appHasPermission="derivativeCalculatorPermissions.MODULE">
  <div class="ndf-calculator-list__header">
    <app-breadcrumb [home]="home" [items]="breadcrumbs"></app-breadcrumb>
    <div class="ndf-calculator-list__header__map d-none">
      <i class="pi pi-map d-none"></i>
    </div>
  </div>
  <div class="ndf-calculator-list__header">
    <div class="ndf-calculator-list__header__title">
      <h1 class="mb-0 mb-md-2">{{ tk.Management.NdfDemandManagement | t }}</h1>
    </div>
  </div>
  <div class="ndf-calculator-list__header__search px-3">
    <div class="form-search me-3 d-none d-md-flex mb-2">
      <app-select
        [multiple]="true"
        [placeholder]="tk.Management.CompanyAllCompanys | t"
        [options]="companyOptions"
        [selectedOptions]="selectedCompany"
        (sendSelectedOptionMultiple)="handleOptionsChange($event, 'selectedCompany')">
      </app-select>
    </div>
    <div class="d-flex">
      <ng-container *appHasPermission="derivativeCalculatorPermissions.SIMULATE">
        <app-button
          class="me-2"
          [id]="'add-group'"
          [label]="isMobile ? '' : (tk.Management.NdfNewDemand | t)"
          [icon]="'pi pi-plus'"
          [type]="'button'"
          (sendButtonClick)="addNdfQuotation()">
        </app-button>
      </ng-container>
      <app-button
        class="me-2"
        [id]="'add-group'"
        [label]="isMobile ? '' : (tk.Management.NdfImport | t)"
        [icon]="'pi pi-upload'"
        [theme]="'darkblue'"
        [type]="'button'">
      </app-button>
      <app-button
        [id]="'add-group'"
        [label]="tk.Management.NdfExportToExcel | t"
        [icon]="'pi pi-download'"
        [theme]="'darkblue'"
        [type]="'button'">
      </app-button>
    </div>
  </div>
  <div class="ndf-calculator-list__content mt-3">
    <ng-container [ngSwitch]="tabViewActiveIndex">
      <ng-container *ngSwitchDefault>
        <div class="d-flex justify-content-between">
          <div class="w-25">
            <app-search
              [isLoading]="isLoading"
              [value]="search"
              [placeholder]="(tk.General.Search | t) || ''"
              (sendSearch)="handleSearch($event)">
            </app-search>
          </div>
          <div class="d-flex align-items-center">
            <!-- Toggle de visualização -->
            <div class="view-mode-toggle me-3">
              <app-button
                [id]="'view-cards'"
                [icon]="'pi pi-th-large'"
                [theme]="'white'"
                [selected]="viewMode === 'cards'"
                [label]="'Cards'"
                [class]="'me-2'"
                (sendButtonClick)="setViewMode('cards')">
              </app-button>
              <app-button
                [id]="'view-table'"
                [icon]="'pi pi-table'"
                [theme]="'white'"
                [selected]="viewMode === 'table'"
                [label]="'Tabela'"
                (sendButtonClick)="setViewMode('table')">
              </app-button>
            </div>
            <app-button
              [id]="'filter-all'"
              [icon]="'pi pi-filter-slash'"
              [theme]="'white'"
              [label]="tk.General.Filter | t"
              (sendButtonClick)="handleFilterActive(true)">
            </app-button>
          </div>
        </div>
        <!-- Filtros Ativos -->
        <app-active-filters
          [filterConfigs]="activeFilterConfigs"
          [showClearButton]="true"
          [clearButtonLabel]="'Limpar filtros'"
          (filterRemoved)="onRemoveFilter($event)"
          (allFiltersCleared)="onClearAllFilters()">
        </app-active-filters>
      </ng-container>
      <ng-container *ngIf="ndfDemands.length; else templateNoDemands">
        <!-- Visualização em Cards -->
        <ng-container *ngIf="viewMode === 'cards'">
          <app-ndf-card-summary
            *ngFor="let ndfDemand of ndfDemands; let iDemand = index"
            [ndfDemand]="ndfDemand"
            [operations]="ndfDemand?.operations || []"
            (sendFillOperation)="fillOperation($event, iDemand)"
            (sendCardSummaryAction)="handleCardSummaryAction($event)">
          </app-ndf-card-summary>
        </ng-container>

        <!-- Visualização em Tabela -->
        <ng-container *ngIf="viewMode === 'table'">
          <app-table
            [hasFilter]="false"
            [reorderableColumns]="true"
            [resizableColumns]="true"
            [sortable]="true"
            [hasCheckbox]="false"
            [enableGroupHeaders]="true"
            [totalRecords]="pagination.total"
            [items]="ndfDemands"
            [showSearch]="false"
            [columnDefinitions]="columnDefinitions"
            [rows]="pagination.itemsPerPage || 10"
            [firstRow]="firstRow"
            [getOptionsFunction]="getMenuActions.bind(this)"
            [allowSelectColumns]="true"
            [hasPagination]="false"
            (sendTableAction)="handleTableAction($event)"
            (sendTableSort)="handleTableSort($event)">
            <!-- Template customizado para sequentialId -->
            <ng-template appNamedTemplate="sequentialId" let-item>
              <a
                class="text-primary text-decoration-none fw-bold"
                [routerLink]="['/dashboard/control/derivative-management/derivatives/list']"
                [queryParams]="{ demandId: item.id }"
                style="cursor: pointer">
                {{ item.sequentialId }}
              </a>
            </ng-template>

            <!-- Template customizado para operation -->
            <ng-template appNamedTemplate="operation" let-item>
              {{ getOperationTypeLabel(item.operation) }}
            </ng-template>

            <!-- Template customizado para totalOperations -->
            <ng-template appNamedTemplate="totalOperations" let-item>
              <span
                pTooltip="Em aberto / Total de operações contratadas / Total de operações"
                tooltipPosition="top"
                style="cursor: help">
                <span style="color: #059669; font-weight: 600">
                  {{ item.totalOperationsHiredAndOpen || 0 }}
                </span>
                /
                <span style="color: #374151">
                  {{ item.totalOperationsHired || 0 }}
                </span>
                /
                <span style="color: #3b82f6; font-weight: 600">
                  {{ item.totalOperations || 0 }}
                </span>
              </span>
            </ng-template>

            <!-- Template customizado para operações relacionadas -->
            <ng-template appNamedTemplate="relatedOperations" let-item>
              <div class="d-flex gap-1 flex-wrap">
                <!-- Link para Comex Operation -->
                <a
                  *ngIf="item.comexOperation?.sequentialId"
                  class="badge bg-primary text-decoration-none small"
                  [routerLink]="['/dashboard/comex-operation/v1/details', item.comexOperation.id]"
                  [title]="'Operação Comex: ' + item.comexOperation.sequentialId">
                  {{ item.comexOperation.sequentialId }}
                </a>

                <!-- Link para Loan Operation -->
                <a
                  *ngIf="item.loanOperation?.sequentialId"
                  class="badge bg-info text-decoration-none small"
                  [routerLink]="[
                    '/dashboard/costs/debt/management/launch-installments',
                    item.loanOperation.id,
                  ]"
                  [title]="'Operação de Empréstimo: ' + item.loanOperation.sequentialId">
                  {{ item.loanOperation.sequentialId }}
                </a>

                <!-- Indicativo se não há operações relacionadas -->
                <span
                  *ngIf="
                    !item.comexOperation?.sequentialId &&
                    !item.loanOperation?.sequentialId &&
                    item.operation !== 'Indicative'
                  "
                  class="badge bg-warning small"
                  title="Demanda sem operação vinculada">
                  SEM VÍNCULO
                </span>

                <!-- Para operações indicativas -->
                <span *ngIf="item.operation === 'Indicative'" class="badge bg-secondary small">
                  INDICATIVO
                </span>
              </div>
            </ng-template>

            <!-- Template customizado para reference -->
            <ng-template appNamedTemplate="reference" let-item>
              <span [title]="getFormattedReference(item.reference) || '-'">
                {{
                  getFormattedReference(item.reference) &&
                  getFormattedReference(item.reference).length > 20
                    ? (getFormattedReference(item.reference) | slice: 0 : 20) + '...'
                    : getFormattedReference(item.reference) || '-'
                }}
              </span>
            </ng-template>

            <!-- Template customizado para userName -->
            <ng-template appNamedTemplate="userName" let-item>
              <span [title]="item.userName || '-'">
                {{ item.userName || '-' }}
              </span>
            </ng-template>

            <!-- Template vazio -->
            <ng-template #emptyTemplate let-items>
              <div class="ndf-calculator-list__empty">
                <h4>{{ tk.Management.NoDemandRegistered | t }}</h4>
              </div>
            </ng-template>
          </app-table>
        </ng-container>
      </ng-container>
      <ng-template #templateNoDemands>
        <div class="ndf-calculator-list__empty">
          <h4>{{ tk.Management.NoDemandRegistered | t }}</h4>
        </div>
      </ng-template>
    </ng-container>
  </div>
  <div class="ndf-calculator-list__footer">
    <p-paginator
      #paginator
      (onPageChange)="handlePagination($event)"
      [first]="firstRow"
      [rows]="pagination.itemsPerPage || 5"
      [totalRecords]="pagination.total"
      [rowsPerPageOptions]="rowsPerPageOptions" />
  </div>

  <!-- INÍCIO Create demand dialodg -->

  <app-dialog
    [key]="'create-demand'"
    [action]="'create-demand'"
    [headerTheme]="'simple'"
    (sendDialogAction)="handleDialogAction($event)"
    [title]="(tk.Management.NdfCreateDemand | t) || ''">
    <div class="ndf-calculator-list__dialog px-2">
      <form *ngIf="demandForm" [formGroup]="demandForm" appAutoFormGroup>
        <div class="container-fluid px-0">
          <h3 class="mb-4 mt-2">{{ tk.Management.NdfDemand | t }}</h3>
          <div class="row px-0">
            <div class="col-5 mb-3">
              <app-select-company
                class="w-100"
                [formGroup]="demandForm"
                [controlName]="demandRegisterProps.companyId"
                [label]="tk.Management.Company | t"
                (sendSelectedOption)="handleOptionChange($event, 'companyId')"
                [placeholder]="tk.User.Select | t">
              </app-select-company>
            </div>

            <div class="col-7">
              <app-select
                class="w-100"
                [label]="(tk.Control.OperationType3 | t) + ' *'"
                [options]="operationOptions"
                [formGroup]="demandForm"
                [controlName]="demandRegisterProps.operationType"
                (sendSelectedOption)="handleOptionChange($event, 'operationType')"
                [placeholder]="tk.User.Select | t"
                [disabled]="!selectedCompanyDialog?.value">
              </app-select>
            </div>
          </div>

          <!-- COMEX Operations Select -->
          <div class="row px-0" *ngIf="showComexOperations">
            <div class="col-12 mb-3">
              <app-select
                class="w-100"
                [label]="(tk.Management.NdfOperation | t) + ' *'"
                [options]="comexOperations"
                [selectedOption]="selectedComexOperation"
                [formGroup]="demandForm"
                [controlName]="'comexOperationId'"
                (sendSelectedOption)="handleOptionChange($event, 'comexOperation')"
                [placeholder]="tk.User.Select | t">
              </app-select>
            </div>
          </div>

          <!-- Loan Operations Select -->
          <div class="row px-0" *ngIf="showLoanOperations">
            <div class="col-12 mb-3">
              <app-select
                class="w-100"
                [label]="(tk.Management.NdfOperation | t) + ' *'"
                [options]="loanOperations"
                [selectedOption]="selectedLoanOperation"
                [formGroup]="demandForm"
                [controlName]="'loanOperationId'"
                (sendSelectedOption)="handleOptionChange($event, 'loanOperation')"
                [placeholder]="tk.User.Select | t">
              </app-select>
            </div>
          </div>

          <!-- Indicative Fields -->
          <ng-container *ngIf="showIndicativeFields">
            <div class="row px-0">
              <div class="col-6 mb-3">
                <app-input
                  [formGroup]="demandForm"
                  [type]="'text'"
                  [controlName]="demandRegisterProps.reference"
                  [label]="tk.Management.NdfReference | t"
                  [required]="false">
                </app-input>
              </div>
              <div class="col-6 mb-3">
                <app-select
                  class="w-100"
                  [label]="(tk.Management.NdfCurrency | t) + ' *'"
                  [options]="currencyOptions"
                  [selectedOption]="selectedCurrency"
                  [formGroup]="demandForm"
                  [controlName]="demandRegisterProps.internationalCurrencyId"
                  (sendSelectedOption)="handleOptionChange($event, 'internationalCurrencyId')"
                  [placeholder]="tk.User.Select | t">
                </app-select>
              </div>
            </div>
            <div class="row px-0">
              <div class="col-3 mb-3">
                <app-input
                  [type]="'number'"
                  [label]="(tk.Management.NdfValue | t) || ''"
                  [controlName]="demandRegisterProps.transactionValue"
                  [formGroup]="demandForm"
                  [minFractionDigits]="2"
                  [maxFractionDigits]="2"
                  [min]="0"
                  [required]="false"
                  (sendInputValue)="handleInputNumber($event, 'transactionValue')" />
              </div>
              <div class="col-3 mb-3">
                <app-input
                  [type]="'number'"
                  [label]="(tk.Management.BudgetRate1 | t) || ''"
                  [controlName]="demandRegisterProps.budgetRate"
                  [formGroup]="demandForm"
                  [minFractionDigits]="4"
                  [min]="0"
                  [required]="false"
                  (sendInputValue)="handleInputNumber($event, 'budgetRate')" />
              </div>
              <div class="col-6 mb-3">
                <app-calendar
                  [formGroup]="demandForm"
                  [controlName]="demandRegisterProps.dueAt"
                  [label]="(tk.Management.NdfDueDate | t) || ''"
                  [placeholder]="(tk.General.Insert | t) || ''"
                  [minDate]="minDueDate"
                  [inputId]="'demand-dueat'"
                  (sendCalendarValue)="handleCalendarValue($event, 'dueAt')" />
              </div>
            </div>
          </ng-container>
          <div class="row px-0"></div>
        </div>
      </form>
    </div>

    <app-button
      [id]="'aa'"
      [label]="tk.General.Next | t"
      [type]="'button'"
      (click)="saveNdfQuotation()">
    </app-button>
  </app-dialog>

  <!-- FIM Create demand dialod -->

  <!-- FIM Create simulation dialod -->

  <app-dialog
    [key]="'demand-should-remove'"
    [action]="'demand-should-remove'"
    [icon]="''"
    [title]="(tk.Management.NdfDemandTitleDeleteConfirmation | t) || ''"
    [headerTheme]="'none'">
  </app-dialog>

  <app-ndf-calculator-filter
    [isActive]="activeFilter"
    [currentFilters]="currentNdfFilters"
    (sendCloseFilter)="handleFilterActive($event)"
    (sendFilter)="handleFilter($event)"
    (sendActiveFilters)="onActiveFiltersChange($event)">
  </app-ndf-calculator-filter>
</section>

<app-ndf-edit-demand (sendSuccessUpdate)="handleSuccessUpdate()" #editDemand></app-ndf-edit-demand>

<app-derivative-mtm-results-modal #resultsModal></app-derivative-mtm-results-modal>
